export default "__VITE_ASSET__d4Ox_hPx__"